import leadApi from '@features/leads/services/lead-api';
import { AssigneeList } from '@features/participants/pages/detail/components/participant-progress/assignee-list';

import type { TSubmission } from '@shared/types/submission';
import type { TLead } from '@src/shared/types/lead';

export const LeadAssigneeListCell = ({ lead }: { lead: TLead }) => {
  const { mutate: updateLead } = leadApi.useUpdate();

  return (
    <AssigneeList
      submission={lead as unknown as TSubmission}
      showTrigger={false}
      onSelect={(newAssigneeId) => {
        updateLead({
          id: lead.id,
          assignee: newAssigneeId ? Number(newAssigneeId) : null,
        });
      }}
    />
  );
};
